import { managerActions } from '@store/reducers/manager/actions'
import { useDispatch } from 'react-redux'
import { useSearchParams } from 'react-router-dom'

export const useProjectBaseActions = () => {
  const dispatch = useDispatch()

  const [params] = useSearchParams()

  const teamId = params.get('teamId')

  return {
    saveProject: () => {
      dispatch(managerActions.saveProjectSaga({ teamId }))
    },

    deleteProject: (payload: any) => {
      dispatch({ type: 'DELETE_PROJECT', payload })
    },
  }
}
